import localForage from 'localforage';
import CommonService from './CommonService';
let instance = null;
let CS = new CommonService();

export default class StorageService {
	constructor() {
		if (instance) {
			return instance;
		}
		this.sessionId = CS.UUID();
		this.componentStore = localForage.createInstance({
			name: 'session'
		});
		this.userStore = localForage.createInstance({
			name: 'userStore'
		});
		instance = this;
	}

	getSessionId() {
		return this.sessionId;
	}

	storeComponentData(key, state) {
		if (key) {
			this.componentStore.setItem(key, {
				sessionId: this.getSessionId(),
				updated: new Date(),
				data: state
			});
		}
	}

	getComponentData(key, session) {
		return this.componentStore.getItem(key).then(res => {
			if (res && res.data && ((session && res.sessionId === this.getSessionId()) || !session)) {
				return Promise.resolve(res.data);
			} else {
				return Promise.resolve(null);
			}
		});
	}

	getUserData(key) {
		return this.userStore.getItem(key);
	}

	setUserData(key, value) {
		this.userStore.setItem(key, value);
	}
}



// WEBPACK FOOTER //
// ./src/services/StorageService.js